/*
EXAMPLE USAGE

<footer-signup
  data-success-email="Thanks for signing up!"
  data-success-sms="You're in!"
  data-fail-sms="Unable to subscribe.">

  <div data-email-wrap>
    {% form 'customer' %}
      <input type="hidden" name="contact[tags]" value="newsletter">
      ... email input + submit button ...
    {% endform %}
  </div>

  <form data-sms-form>
    ... phone input + submit button ...
  </form>

</footer-signup>
*/

if (!customElements.get('footer-signup')) {
  customElements.define('footer-signup', class FooterSignup extends HTMLElement {
    connectedCallback() {
      this.emailForm = this.querySelector('[data-email-wrap] form');
      this.smsForm   = this.querySelector('[data-sms-form]');

      this.emailForm?.addEventListener('submit', e => this.handleEmail(e));
      this.smsForm?.addEventListener('submit',   e => this.handleSms(e));
    }

    async handleEmail(e) {
      e.preventDefault();
      const form  = e.currentTarget;
      const email = form.querySelector('[name="contact[email]"]')?.value;

      try {
        const res = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (res.ok) {
          if (email) sessionStorage.setItem('fs_attn_email', email);
          this.showState(form, 'success');
        } else {
          this.showState(form, 'error');
        }
      } catch {
        this.showState(form, 'error');
      }
    }

    async handleSms(e) {
      e.preventDefault();
      const form  = e.currentTarget;
      const phone = form.querySelector('[name="phone"]')?.value;

      if (phone) sessionStorage.setItem('fs_attn_phone', phone);

      const data = new FormData();
      data.set('phone', phone);

      const email = sessionStorage.getItem('fs_attn_email');
      if (email) data.set('email', email);

      try {
        const res = await fetch('https://47.sparkyapps.dev/attn/subscribe', {
          method: 'POST',
          body: data,
        });

        if (res.ok) {
          this.querySelector('[data-email-wrap]')?.classList.add('hidden');
          this.showState(form, 'success', this.dataset.successSms);
        } else {
          this.showState(form, 'error', this.dataset.failSms);
        }
      } catch {
        this.showState(form, 'error', this.dataset.failSms);
      }
    }

    showState(form, state, msg) {
      form.querySelector('[data-fields]')?.classList.add('hidden');
      const el = form.querySelector(`[data-${state}]`);
      if (!el) return;
      if (msg) el.textContent = msg;
      el.classList.remove('hidden');
    }
  });
}
